import React, { useMemo } from 'react';

import { Carousel } from 'antd';
import { RemoveLuxuryHomesParams, RootState } from '@share/utils';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Routes, DEFAULT_MEDIA_POINT } from '@share/constants';
import { ILuxuryHomeLocation } from '@share/common-types';

import './style.scss';

const slidesToShow = 3;
const slidesToShowMobile = 1;
const slidesToScroll = 1;

const LuxuryHomesFeaturedDestinations: React.FC = () => {
  const history = useHistory();

  const { account} = useSelector((state: RootState) => state.loginStore);

  const { locations } = useSelector((state: RootState) => state.luxuryHomesStore);

  const goToPlace = (placeId: number) => {
    RemoveLuxuryHomesParams();

    history.push(`/${account?.name}${Routes.LuxuryHomesPlace}/${placeId}${location.search}`);
  };

  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;
  
  const propsCarousel = useMemo(() => ({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    slidesToShow: isMobile ? slidesToShowMobile : locations?.length < 3 ? locations?.length : slidesToShow,
    slidesToScroll,
  }), [locations?.length]);
  
  return (
    <section className="featured-destinations">
      <div className="featured-destinations__header">
        <h2>FEATURED DESTINATIONS</h2>
        <h3>Our Most Sought-After Destinations</h3>
        <p>Extraordinary homes, handpicked by travelers like you. These sought-after offer unparalleled luxury, breathtaking views, and unforgettable experiences.</p>
      </div>

      <Carousel {...propsCarousel}>
        {locations.map((location: ILuxuryHomeLocation, index: number) => (
          <div key={index} className="destination-card" onClick={() => goToPlace(location.id)}>
            <div className="destination-card__image" style={{ maxWidth: '372px', backgroundImage: `url(${location.image})` }}>
              <div className="destination-card__image-background"></div>
              <div className="destination-card__content">
                <h3>{location.name}</h3>
                <p>{location.country}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default LuxuryHomesFeaturedDestinations; 